<template>
	<div id="switch-trip">
		<div class="buisness-travel df-jsb-aic" :class="{ 'mt2': !isPhone }">
			<h3 class="raleway-semi-p13 mb-0">Animaux <span v-if="getFilterCount('animal')" class="filter-count">({{ getFilterCount('animal') }})</span></h3>
			<input type="checkbox" id="animal" v-model="selected" /><label class="m-0" for="animal">Animal</label>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'switch-trip',
		props: ['filterCounts'],
		data() {
			return {
				selected: false,
			};
		},
		methods: {
			getFilterCount(filterType) {
				if (!this.filterCounts || !this.filterCounts.has_animal_friendly) return 0;
				// Find the count for true values (animal-friendly lodgings)
				const animalData = this.filterCounts.has_animal_friendly.find(item => item.key === 1);
				return animalData ? animalData.count : 0;
			},
		},
		watch: {
			selected(val) {
				// easier to handle only arrays
				this.$emit('checked', val, 'animal');
			},
		},
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        } else {
          return false;
        }
      },
    }
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
